/**
 * ReactQuill configuration and styles
 */

// Configure ReactQuill modules
export const quillModules = {
  toolbar: [
    [{ 'header': 2 }, { 'header': 3 }], // H2, H3 (no H1 - reserved for post title)
    ['emoji', 'bold', 'italic', 'underline', 'strike'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    ['link'], // Inline media buttons hidden until Idea #9/#10 ship
    ['clean'] // Remove formatting button
  ],
  'emoji-toolbar': true,
  'emoji-textarea': false,
  'emoji-shortname': true,
  clipboard: {
    // Match visual styling in the editor
    matchVisual: false
  }
};

// Configure ReactQuill formats
export const quillFormats = [
  'header', 'list', 'bullet',
  'bold', 'italic', 'underline', 'strike',
  'link', 'emoji',
  'clean'
];

// Component for Quill editor custom styling
export const QuillStyles = () => (
  <style>{`
    .ql-container {
      font-family: "Inter", "Segoe UI", system-ui, sans-serif;
      font-size: 1rem;
      color: #4a5568;
      border: 1px solid #e2e8f0 !important;
      border-top: none !important;
      border-radius: 0 0 8px 8px !important;
    }
    
    .ql-editor {
      min-height: 350px;
      max-height: 500px;
      overflow-y: auto;
      padding: 16px;
      line-height: 1.6;
    }
    
    .ql-editor.ql-blank::before {
      color: #a0aec0;
      font-style: normal;
    }
    
    .ql-toolbar {
      border: none !important;
      border-bottom: 1px solid #e2e8f0 !important;
      padding: 8px;
      background-color: #f7fafc;
    }
    
    .ql-toolbar button:hover,
    .ql-toolbar button.ql-active {
      color: #667eea !important;
    }
    
    .ql-toolbar .ql-picker-label:hover,
    .ql-toolbar .ql-picker-label.ql-active {
      color: #667eea !important;
    }
    
    /* Fix z-index for link/image/video popups and tooltips */
    .ql-tooltip {
      z-index: 9999 !important;
    }
    
    .ql-tooltip.ql-editing {
      z-index: 9999 !important;
    }
    
    /* Ensure tooltip arrow is visible */
    .ql-tooltip::after {
      z-index: 9999 !important;
    }
    
    /* Style links in the editor */
    .ql-editor a {
      color: #667eea;
      text-decoration: underline;
    }
    
    .ql-snow a {
      color: #667eea;
      text-decoration: underline;
    }
    .ql-content {
      font-family: "Inter", "Segoe UI", system-ui, sans-serif;
      font-size: 1.05rem;
      line-height: 1.6;
      color: #4a5568;
    }

    .ql-content p {
      margin: 0 0 0.15rem;
    }

    /* Targeted overrides to remove extra margins from Bootstrap or inherited styles */
    /* PostDetail page - remove ALL margins/padding to match editor EXACTLY */
    .post-content-text.ql-content {
      font-size: 1rem !important;
      line-height: 1.6 !important;
    }

    .post-content-text.ql-content p {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      line-height: 1.6 !important;
      font-size: 1rem !important;
    }

    .post-content-text.ql-content h2,
    .post-content-text.ql-content h3,
    .post-content-text.ql-content h4 {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      line-height: 1.3 !important;
    }

    .post-content-text.ql-content ul,
    .post-content-text.ql-content ol {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-left: 1.5rem !important;
    }

    .post-content-text.ql-content li {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      line-height: 1.6 !important;
    }

    /* PostCard excerpt - remove ALL margins */
    .post-card-excerpt.ql-content {
      font-size: 0.95rem !important;
      line-height: 1.6 !important;
    }

    .post-card-excerpt.ql-content p {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      line-height: 1.6 !important;
      font-size: 0.95rem !important;
    }

    .post-card-excerpt.ql-content h2,
    .post-card-excerpt.ql-content h3,
    .post-card-excerpt.ql-content h4 {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      line-height: 1.3 !important;
    }

    .post-card-excerpt.ql-content ul,
    .post-card-excerpt.ql-content ol {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-left: 1.5rem !important;
    }

    .post-card-excerpt.ql-content li {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      line-height: 1.6 !important;
    }

    /* Also target direct children to be super explicit */
    .post-content-text.ql-content > p,
    .post-card-excerpt.ql-content > p {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }



    .ql-content h2,
    .ql-content h3,
    .ql-content h4 {
      margin: 1.5rem 0 0.75rem;
      color: #2d3748;
      font-weight: 600;
    }

    .ql-content ul,
    .ql-content ol {
      padding-left: 1.5rem;
      margin: 0 0 1.5rem;
    }

    .ql-content li {
      margin: 0.25rem 0;
    }

    .ql-content blockquote {
      border-left: 4px solid #cbd5f5;
      margin: 1.5rem 0;
      padding-left: 1rem;
      color: #4a5568;
      font-style: italic;
      background: #f7fafc;
    }

    .ql-content a {
      color: #667eea;
      text-decoration: underline;
    }

    .ql-content img {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
    }

  `}</style>
);
